module.exports = __webpack_public_path__ + "img/clock-nine.5d0014d2.svg";